import React, { useState, useEffect ,useRef} from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../Assets/images1-removebg-preview.png";
import gsap from "gsap";
import { useGSAP } from "@gsap/react"; 
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineMail,
} from "react-icons/ai";
import { CgFileDocument } from "react-icons/cg";
import { GiGears } from "react-icons/gi";
import { BsSun, BsMoon } from "react-icons/bs";
import LivePreviewButton from "./livePreview";
import { FaVideo } from "react-icons/fa";

function NavBar() {
  const [expand, setExpand] = useState(false);
  const [navColour, setNavColour] = useState(false);
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "dark"
  );

  useEffect(() => {
    const onScroll = () => {
      setNavColour(window.scrollY >= 20);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

 const thumbRef = useRef(null);
  const iconRef = useRef(null);
  const containerRef = useRef(null);


  useGSAP(() => {
    // Slide the thumb
    gsap.to(thumbRef.current, {
      x: theme === "light" ? 22 : 0, // Adjusted distance
      backgroundColor: theme === "dark" ? "#111" : "#fff",
      duration: 0.4,
      ease: "power3.out",
    });

    // Rotation effect for the icon
    gsap.fromTo(iconRef.current, 
      { rotation: -120, opacity: 0, scale: 0.5 },
      { rotation: 0, opacity: 1, scale: 1, duration: 0.4, ease: "back.out(1.7)" }
    );
  }, { dependencies: [theme], scope: containerRef });

  const handleToggle = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };


  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
      ref={containerRef}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <img src={logo} className="img-fluid logo" alt="brand" />
        </Navbar.Brand>

        <Navbar.Toggle
          onClick={() => setExpand(expand ? false : "expanded")}
        />

        <Navbar.Collapse>
          <Nav className="ms-auto">
            <Nav.Item>
              <a href="/#home" className="nav-link" onClick={() => setExpand(false)}>
                <AiOutlineHome /> Home
              </a>
            </Nav.Item>

            <Nav.Item>
              <a href="/#services" className="nav-link" onClick={() => setExpand(false)}>
                <GiGears /> Services
              </a>
            </Nav.Item>

            <Nav.Item>
              <a href="/#projects" className="nav-link" onClick={() => setExpand(false)}>
                <AiOutlineFundProjectionScreen /> Projects
              </a>
            </Nav.Item>

            <Nav.Item>
              <a href="/#resume" className="nav-link" onClick={() => setExpand(false)}>
                <CgFileDocument /> Resume
              </a>
            </Nav.Item>

            <Nav.Item>
              <a href="/#contact" className="nav-link" onClick={() => setExpand(false)}>
                <AiOutlineMail /> Contact
              </a>
            </Nav.Item>
<Nav.Item>
  <LivePreviewButton
    url="https://cal.com/m.ali"
    innerText="Book Meeting"
    icon={FaVideo}
    onClick={() => setExpand(false)}
  />
</Nav.Item>

  <Nav.Item>
              <div onClick={handleToggle} className="theme-switch-track">
                <div ref={thumbRef} className="theme-switch-thumb">
                  <span ref={iconRef} style={{ display: "flex" }}>
                    {theme === "dark" ? <BsSun size={14} color="#FFA500" /> : <BsMoon size={14} color="#333" />}
                  </span>
                </div>
              </div>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
